/** @jsxImportSource @emotion/react */
import { Box, Typography, List, ListItem, ListItemText, Avatar, Divider } from '@mui/material'
import { useMemo } from 'react'
import type { UserProfile } from '@app/types'
import { listContainer } from '../styles/Admin.styles'

interface Props {
  users: UserProfile[]
}

export const AdminTopUsersList = ({ users }: Props) => {
  const topUsers = useMemo(() => {
    return [...users]
      .sort((a, b) => Number(b.logged_in_count ?? 0) - Number(a.logged_in_count ?? 0))
      .slice(0, 5)
  }, [users])

  return (
    <Box css={listContainer}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight={600}>
          Top 5 Most Active Users
        </Typography>
      </Box>

      {topUsers.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No login activity
        </Typography>
      ) : (
        <List dense>
          {topUsers.map((user, idx) => (
            <Box key={user.user_uuid}>
              <ListItem disableGutters>
                <Avatar sx={{ mr: 2 }}>{user.email.charAt(0).toUpperCase()}</Avatar>
                <ListItemText
                  primary={
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="body1" fontWeight={600}>
                        {idx + 1}. {user.email}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {user.logged_in_count} logins
                      </Typography>
                    </Box>
                  }
                  secondary={
                    user.last_logged_in
                      ? new Date(user.last_logged_in).toLocaleDateString()
                      : 'No recent activity'
                  }
                />
              </ListItem>
              {idx < topUsers.length - 1 && <Divider css={{ 'border-color': '#d9d9d9' }} />}
            </Box>
          ))}
        </List>
      )}
    </Box>
  )
}
